import React, { useEffect } from 'react';
import { ButtonVariant, useModal, ButtonColor } from '@ampol/design-system';

import './confirm-exit-modal.scss';

interface ConfirmExitModalProps {
  title: string;
  content: React.ReactNode;
  color?: ButtonColor;
  onConfirmExitClick: () => void;
  onClose?: () => void;
  submitLabel?: string;
  variant?: 'single' | 'double' | 'triple' | 'fullscreen' | 'dynamic';
  id?: string;
}

/**
 * Describe component here
 * @param props
 */
const ConfirmExitModal = ({
  title,
  content,
  color = ButtonColor.Blue,
  onConfirmExitClick,
  onClose,
  submitLabel,
  variant,
  id,
}: ConfirmExitModalProps) => {
  const confirm = useModal({
    id: id || 'confirm-exit-modal',
    title: title,
    content: content,
    color: color,
    variant: variant,
    actions: [
      {
        label: submitLabel || 'Confirm and Exit',
        onClick: () => {
          onConfirmExitClick();
          confirm.close();
        },
        variant: ButtonVariant.Primary,
      },
      {
        label: 'Cancel',
        onClick: () => confirm.close(),
      },
    ],
    hideCloseButton: true,
    onClose: onClose,
  });

  useEffect(() => {
    confirm.open();
  }, []);

  return <div className={'confirm-exit-modal'}></div>;
};

export default ConfirmExitModal;
